import React from "react";
import { IdentifierField } from "../../../../common/components/IdentifierField";

/**
 * Componente custom para el campo MusicalWork.iswc. Al salir del campo guarda el ISWC
 * como T0345246801, lo muestra como T-034.524.680-1 y muestra el error de la regla; el
 * detalle está en IdentifierField, común a los cuatro campos de identificadores.
 *
 * Llená/editá este archivo en `develop`. El generador lo emite como stub estable en
 * `base` (merge-safe). Recibe los mismos props que un control estándar del form.
 */
export interface MusicalWorkIswcCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const MusicalWorkIswcCustomField: React.FC<MusicalWorkIswcCustomFieldProps> = (
  props
) => <IdentifierField kind="iswc" optional {...props} />;
